import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import './component.css';

const useStyles = makeStyles((theme) => ({
  scrollButton: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    opacity: 0,
    transition: 'opacity 0.3s',
    zIndex: 9999,
  },
  visible: {
    opacity: 1,
  },
}));

const ScrollButton = () => {
  const classes = useStyles();
  const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);
  const [isVisible, setIsVisible] = useState(false);
  const scrollButtonRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const isVisible = prevScrollPos > currentScrollPos && currentScrollPos > 0;

      setPrevScrollPos(currentScrollPos);
      setIsVisible(isVisible);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [prevScrollPos]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Fab
      ref={scrollButtonRef}
      color="primary"
      style={{ backgroundColor: 'rgba(66, 66, 66, 0.7)' }}
      className={`${classes.scrollButton} ${isVisible ? classes.visible : ''}`}
      onClick={scrollToTop}
    >
      <KeyboardArrowUpIcon style={{ fontSize: '2.5rem' }} />
    </Fab>
  );
};

export default ScrollButton;
